module.exports = __webpack_public_path__ + "static/media/create-page-wizard2.7463c6bd.png";